import Vue from 'vue'
import { visibleGuideElement } from './registry'

// Runtime identities belong to mounted page instances, never to stored guides.
export const guidePageContexts = Vue.observable({ contexts: [] })
let nextOrder = 0

export function registerGuidePageContext(definition) {
  const entry = { ready: false, variant: null, templateKey: null, ...definition, order: ++nextOrder }
  guidePageContexts.contexts.push(entry)
  return () => {
    guidePageContexts.contexts = guidePageContexts.contexts.filter(context => context !== entry)
  }
}

export function updateGuidePageContext(instanceId, patch) {
  const entry = guidePageContexts.contexts.find(context => context.instanceId === instanceId)
  if (!entry) return
  Object.keys(patch).forEach(key => Vue.set(entry, key, patch[key]))
}

export function getVisibleGuidePageContexts() {
  return guidePageContexts.contexts.map(context => ({
    ...context,
    element: typeof context.element === 'function' ? context.element() : context.element,
  })).filter(context => !context.embedded && visibleGuideElement(context.element))
}

export function getActiveGuidePageContext() {
  const contexts = getVisibleGuidePageContexts().map(context => {
    const dialog = context.element.closest('.v-dialog--active')
    const content = dialog && dialog.closest('.v-dialog__content')
    return { ...context, dialog, layer: content ? Number.parseInt(getComputedStyle(content).zIndex, 10) || 0 : 0 }
  })
  contexts.sort((first, second) => {
    if (!!first.dialog !== !!second.dialog) return first.dialog ? 1 : -1
    if (first.layer !== second.layer) return first.layer - second.layer
    // Embedded tabs, search panes and expanded rows do not replace their host page.
    if (!!first.primary !== !!second.primary) return first.primary ? 1 : -1
    if (first.element !== second.element && first.element.compareDocumentPosition) {
      const position = first.element.compareDocumentPosition(second.element)
      if (!(position & 1)) return position & 4 ? -1 : 1
    }
    return first.order - second.order
  })
  // Keep a loading top-level modal here: callers must not fall back to the page behind it.
  return contexts[contexts.length - 1] || null
}
